import AdminApplications from "../../components/Admin/AdminApplications";
import DashboardLayout from "../../components/Layout/DashboardLayout";
import { applicationStageMap } from "../../config/applicationStatusConfig";

const TIFCApplications = () => {
  return (
    <DashboardLayout pageTitle="Application" mainClass="p-6">
      <AdminApplications
        title="TIFC Applications"
        status={[]}
        stage={[applicationStageMap.tifc.value]}
      />
    </DashboardLayout>
  );
};

export default TIFCApplications;
